<template>
    <div class="container-fluid p-0">
        <Loader v-if="loading" />
        <b-alert variant="danger" :show="loadError">
            {{$t('additional_load_error')}}
            <b-button size="sm" @click="loadData">{{$t('retry')}}</b-button>
        </b-alert>
        <span v-if="!loading && !loadError">
            <b-alert class="type-list-error" variant="danger" :show="typeListError">
                {{$t('device_type_load_error')}}
                <b-button size="sm" @click="loadDeviceTypes">{{$t('retry')}}</b-button>
            </b-alert>
            <b-row>
                <b-row  class="m-md-3 container-fluid">
                    <b-card-header header-bg-variant="primary" header-text-variant="light" class="rounded m-md-3 container-fluid" >
                        {{$t('device_data')}}
                    </b-card-header>
                </b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-col>
                            <b-img v-if="!this.loading"
                                id="image0"
                                height="310"
                                :src="'/assets/devices/' + deviceData.typeId + '.png'"
                                onerror="this.src='/assets/devices/def.png'"
                            >

                            </b-img>
                    </b-col>
                    <b-col>
                        <b-row  cols-lg="mt-2">
                            <b-form  class="m-md-0 container-fluid">
                                <b-form-group
                                    :label-for="deviceInfoData.id.name"
                                    :label="$t('device_list.coll.header.' + deviceInfoData.id.name)"
                                    :id="deviceInfoData.id.name"
                                    class="m-md-0 container-fluid"
                                >
                                    <b-form-input
                                        :placeholder="deviceInfoData.id.name"
                                        v-model="deviceInfoData.id.value"
                                        :id="deviceInfoData.id.name"
                                        data-placement="top"
                                        :title="deviceInfoData.id.name"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-form>
                        </b-row>
                        <b-row  cols-lg="mt-2">
                            <validation-observer class="m-md-0 container-fluid" ref="changeDeviceTypeObserver">
                                <b-form @submit.prevent="onSaveDeviceType"  class="m-md-0 p-0 container-fluid">
                                    <validation-provider vid="deviceType" v-slot="{ errors }" rules="required" >
                                    <b-form-group
                                        :label-for="deviceInfoData.type.name"
                                        :label="$t('device_list.coll.header.' + deviceInfoData.type.name)"
                                        :id="deviceInfoData.type.name"
                                        class="m-md-0 container-fluid"
                                    >
                                        <b-form-select
                                            :placeholder="deviceInfoData.type.name"
                                            v-model="deviceInfoData.deviceType.value"
                                            value-field="id"
                                            text-field="name"
                                            :options="deviceTypeList"
                                            :id="deviceInfoData.type.name"
                                            data-placement="top"
                                            :title="deviceInfoData.type.name"
                                            :disabled="!deviceInfoData.deviceType.changeAvailable || identitySaving || typeListLoading || typeListError"
                                        ></b-form-select>
                                        <div class="text-danger">{{ errors[0] }}</div>
                                        <div class="text-danger identity-error" v-if="identityErrors.deviceType">{{identityErrors.deviceType}}</div>
                                        <div class="text-info" v-if="deviceInfoData.deviceType.savedSuccess">{{$t('saved_successful')}}</div>
                                        <b-button v-if="deviceInfoData.deviceType.changeAvailable" :disabled="identitySaving || typeListLoading || typeListError || !identityChanged('deviceType')" type="submit" variant="primary">{{$t('device.device_type.buttom.change')}}</b-button>

                                    </b-form-group>
                                    </validation-provider>
                                </b-form>
                            </validation-observer>

                        </b-row>
                        <b-row  cols-lg="mt-2">
                            <validation-observer class="m-md-0 container-fluid" ref="changeImeiObserver">
                                <b-form @submit.prevent="onSaveImei" class="m-md-0 p-0 container-fluid">
                                      <validation-provider vid="imei" v-slot="{ errors }" rules="required" >
                                    <b-form-group
                                    :label-for="deviceInfoData.imei.name"
                                    :label="$t('device_list.coll.header.' + deviceInfoData.imei.name)"
                                    :id="deviceInfoData.imei.name"
                                    class="m-md-0 container-fluid"
                                >
                                    <b-form-input
                                        :placeholder="deviceInfoData.imei.name"
                                        v-model="deviceInfoData.imei.value"
                                        :id="deviceInfoData.imei.name"
                                        data-placement="top"
                                        :title="deviceInfoData.imei.name"
                                        :disabled="!deviceInfoData.imei.changeAvailable || identitySaving"
                                    ></b-form-input>
                                        <div class="text-danger">{{ errors[0] }}</div>
                                        <div class="text-danger identity-error" v-if="identityErrors.imei">{{identityErrors.imei}}</div>
                                        <div class="text-info" v-if="deviceInfoData.imei.savedSuccess">{{$t('saved_successful')}}</div>
                                        <b-button v-if="deviceInfoData.imei.changeAvailable" :disabled="identitySaving || !identityChanged('imei')" type="submit" variant="primary">{{$t('device.imei.buttom.change')}}</b-button>

                                </b-form-group>
                              </validation-provider>
                            </b-form>
                            </validation-observer>
                        </b-row>
                        <b-row  cols-lg="mt-2">
                            <b-form  class="m-md-0 container-fluid">
                                <b-form-group
                                    :label-for="deviceInfoData.distributor.name"
                                    :label="$t('device_list.coll.header.' + deviceInfoData.distributor.name)"
                                    :id="deviceInfoData.distributor.name"
                                    class="m-md-0 container-fluid"
                                >
                                    <b-form-input
                                        :placeholder="deviceInfoData.distributor.name"
                                        v-model="deviceInfoData.distributor.value"
                                        :id="deviceInfoData.distributor.name"
                                        data-placement="top"
                                        :title="deviceInfoData.distributor.name"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-form>
                        </b-row>
                        <b-row  cols-lg="mt-2">
                            <validation-observer class="m-md-0 container-fluid" ref="changeDeviceSubTypeObserver">
                                <b-form @submit.prevent="onSaveDeviceSubType"  class="m-md-0 p-0 container-fluid">
                                    <validation-provider vid="deviceSubType" v-slot="{ errors }" rules="required" >
                                    <b-form-group
                                        :label-for="deviceInfoData.sub_type.name"
                                        :label="$t('device_list.coll.header.' + deviceInfoData.sub_type.name)"
                                        :id="deviceInfoData.sub_type.name"
                                        class="m-md-0 container-fluid"
                                    >
                                        <b-form-select
                                            :placeholder="deviceInfoData.sub_type.name"
                                            v-model="deviceInfoData.sub_type.value"
                                            value-field="id"
                                            text-field="name"
                                            :options="deviceSubTypeList"
                                            :id="deviceInfoData.sub_type.name"
                                            data-placement="top"
                                            :title="deviceInfoData.sub_type.name"
                                            :disabled="!deviceInfoData.deviceSubType.changeAvailable || identitySaving"
                                        ></b-form-select>
                                        <div class="text-danger">{{ errors[0] }}</div>
                                        <div class="text-danger identity-error" v-if="identityErrors.deviceSubType">{{identityErrors.deviceSubType}}</div>
                                        <div class="text-info" v-if="deviceInfoData.deviceSubType.savedSuccess">{{$t('saved_successful')}}</div>
                                        <b-button v-if="deviceInfoData.deviceSubType.changeAvailable" :disabled="identitySaving || !identityChanged('deviceSubType')" type="submit" variant="primary">{{$t('device.device_sub_type.buttom.change')}}</b-button>

                                    </b-form-group>
                                    </validation-provider>
                                </b-form>
                            </validation-observer>

                        </b-row>
                        <b-row  cols-lg="mt-2">
                            <b-form  class="m-md-0 container-fluid">
                                <b-form-group
                                    label-for="iccid1"
                                    :label="$t('maps.device.sensors.iccid1')"
                                    id="iccid1"
                                    class="m-md-0 container-fluid"
                                >
                                    <b-form-input
                                        v-model="iccid1.value"
                                        id="iccid1"
                                        data-placement="top"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-form>
                        </b-row>
                        <b-row  cols-lg="mt-2">
                            <b-form  class="m-md-0 container-fluid">
                                <b-form-group
                                    label-for="iccid2"
                                    :label="$t('maps.device.sensors.iccid2')"
                                    id="iccid2"
                                    class="m-md-0 container-fluid"
                                >
                                    <b-form-input
                                        v-model="iccid2.value"
                                        id="iccid2"
                                        data-placement="top"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-form>
                        </b-row>
                    </b-col>
                </b-row>
            </b-row>
            <b-row>
                <validation-observer class="m-md-3 container-fluid" ref="changeAdditionalErrorObserver" v-slot="{ handleSubmit }">
                    <b-form
                            @submit.stop.prevent="handleSubmit(onSubmit)"
                    >
                        <b-card-header header-bg-variant="primary" header-text-variant="light" class="rounded">
                                    {{$t('device_additional_info')}}
                        </b-card-header>
                        <b-row class="ml-4" >
                            <b-button :disabled="savingAdditional || identitySaving" type="submit" variant="primary" class="m-md-2">{{$t('save')}}</b-button>
                        </b-row>
                        <b-row>
                            <b-alert :show="additionalSaveError" variant="danger">{{$t('additional_save_error')}}</b-alert>
                            <b-alert v-model="showSuccessAlert" variant="success" dismissible>
                                {{$t('saved_successful')}}
                            </b-alert>
                        </b-row>
                        <b-row v-for="item in deviceAdditionalInfoFromData" :key="item.name">
                                <b-form-group
                                        :label-for="item.name"
                                        :label="$t('device_additional_info_from_data.' + item.name)"
                                        :id="item.name"
                                        class="m-md-0 container-fluid"
                                >
                                    <b-form-input
                                            :placeholder="$t('device_additional_info_from_data.' + item.name)"
                                            v-model="deviceAdditionalInfo[item.name]"
                                            :disabled="savingAdditional || identitySaving"
                                            :id="item.name"
                                            data-placement="top"
                                            :title="$t('device_additional_info_from_data.' + item.name)"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                    </b-form>

                </validation-observer>
            </b-row>
        </span>
    </div>
</template>

<script>
    import axios from "axios";
    import Loader from "../Common/Loader.vue";


    export default {
        name: "Passport",
        components: { Loader },
        props: {
            id: {
                type: Number
            },
        },
        data() {
            return {
                showSuccessAlert: false,
                loading: true,
                loadError: false,
                savingAdditional: false,
                additionalSaveError: false,
                additionalDataSource: {},
                disposed: false,
                loadRequestId: 0,
                saveRequestId: 0,
                identitySaving: false,
                identityRequestId: 0,
                identityConfirmed: { imei: null, deviceType: null, deviceSubType: null },
                identityErrors: { imei: '', deviceType: '', deviceSubType: '' },
                typeListLoading: false,
                typeListError: false,
                typeListRequestId: 0,
                subTypeRequestId: 0,
                deviceTypeList: [],
                deviceSubTypeList: [],
                deviceInfoData: {
                    id: { value: null, name: 'id',},
                    type: { value: null, name: 'type',},
                    imei: { value: null, name: 'imei', changeAvailable: false, savedSuccess: false},
                    deviceType: { value: null, name: 'deviceType', changeAvailable: false, savedSuccess: false},
                    deviceSubType: { value: null, name: 'deviceSubType', changeAvailable: false, savedSuccess: false},
                    distributor: { value: null, name: 'distributor', disabled: false},
                    sub_type: { value: null, name: 'sub_type', disabled: false},
                    iccid1: { value: null, name: 'iccid1', disabled: false},
                    iccid2: { value: null, name: 'iccid2', disabled: false},
                },
                deviceInfo: [],
                deviceData: {
                    typeId: null,
                },
                deviceTypeId: null,
                deviceAdditionalInfo: {
                    sim1: null,
                    sim2: null,
                    trafficModel: null,
                    registeredNumber: null,
                    object: null,
                    description: null,
                },
                iccid1: {
                    value: null,
                    date: null
                },
                iccid2: {
                    value: null,
                    date: null
                },
                deviceAdditionalInfoFromData: [
                    {name: 'sim1', value: null},
                    {name: 'sim2', value: null},
                    {name: 'trafficModel', value: null},
                    {name: 'registeredNumber', value: null},
                    {name: 'object', value: null},
                    {name: 'description', value: null},
                ]
            }
        },
        mounted() {
            this.loadData();
        },
        beforeDestroy() {
            this.disposed = true;
            this.loadRequestId++;
            this.saveRequestId++;
            this.identityRequestId++;
            this.typeListRequestId++;
            this.subTypeRequestId++;
        },
        watch: {
            id() { this.loadData(); },
            'deviceInfoData.imei.value'() { this.identityErrors.imei = ''; this.deviceInfoData.imei.savedSuccess = false; },
            'deviceInfoData.deviceType.value'() { this.identityErrors.deviceType = ''; this.deviceInfoData.deviceType.savedSuccess = false; },
            'deviceInfoData.sub_type.value'() { this.identityErrors.deviceSubType = ''; this.deviceInfoData.deviceSubType.savedSuccess = false; },
        },
        methods: {
            loadData() {
                if (this.disposed) return;
                const requestId = ++this.loadRequestId;
                const deviceId = this.id;
                const current = () => !this.disposed && requestId === this.loadRequestId;
                this.saveRequestId++;
                this.loading = true;
                this.loadError = false;
                this.showSuccessAlert = false;
                this.additionalSaveError = false;
                this.savingAdditional = false;
                this.additionalDataSource = {};
                this.identityRequestId++;
                this.subTypeRequestId++;
                this.identitySaving = false;
                this.identityConfirmed = { imei: null, deviceType: null, deviceSubType: null };
                this.identityErrors = { imei: '', deviceType: '', deviceSubType: '' };
                ['imei', 'deviceType', 'deviceSubType'].forEach(field => { this.deviceInfoData[field].savedSuccess = false; });
                this.deviceAdditionalInfoFromData.forEach(item => { this.deviceAdditionalInfo[item.name] = null; });

                this.loadDeviceTypes();

                const loading = axios
                    .get('api/v1/devices/' + deviceId + '?lang=' + this.lang)
                    .then((data) => {
                        if (!current()) return;
                        const device = data.data;

                        // let settingsUpdateTime = device.settingsUpdateTime !== null ? new Date(device.settingsUpdateTime.date).toUTCString() : null;
                        // let firmwareUpdateTime = device.firmwareUpdateTime !== null ? new Date(device.firmwareUpdateTime.date).toUTCString() : null;

                        // let version = device.firmwareCurrent;
                        //
                        // if (!device.isFirmwareActual) {
                        //     version = device.firmwareCurrent + ' >> ' + device.firmwareUpdate
                        // }

                        this.deviceInfoData.id.value = device.customId;
                        this.deviceInfoData.type.value = device.deviceTypeName;
                        this.deviceInfoData.deviceType.value = device.typeId;
                        this.deviceInfoData.imei.value = device.imei;
                        this.deviceInfoData.distributor.value = device.distributor;
                        this.deviceInfoData.sub_type.value = device.subTypeId;
                        this.deviceData.typeId = device.typeId;
                        this.deviceTypeId = device.typeId;
                        this.deviceSubTypeList = this.normalizeSubTypes(device.subTypeList);
                        this.identityConfirmed = { imei: device.imei, deviceType: device.typeId, deviceSubType: device.subTypeId };

                        this.additionalDataSource = JSON.parse(JSON.stringify(device.additionalData ?? {}));
                        this.deviceAdditionalInfoFromData.forEach(item => {
                            this.deviceAdditionalInfo[item.name] = this.additionalDataSource[item.name] ?? null;
                        });
                    })
                    .catch(() => { if (current()) this.loadError = true; })
                    .finally(() => { if (current()) this.loading = false; });

                {
                    axios
                        .get('api/v1/devices/' + deviceId + '/coordinates')
                        .then((data) => {
                            if (!current()) return;
                            // console.log(data)
                            this.deviceData.lastDate = data.data.lastDate;
                            const iccid1 = data.data.iccid1;
                            if (iccid1 !== null) {
                                this.iccid1.value = iccid1.value;
                                this.iccid1.date = iccid1.date;
                            }
                            const iccid2 = data.data.iccid2;
                            if (iccid2 !== null) {
                                this.iccid2.value = iccid2.value;
                                this.iccid2.date = iccid2.date;
                            }
                        })
                        .catch(() => {
                            if (!current()) return;
                            this.updateAvailable = false;

                        });
                }

                this.initFutureAvailable();
                return loading;
            },
            normalizeSubTypes(value) {
                // PHP dictionaries with sparse numeric keys are JSON objects, not arrays.
                const options = Array.isArray(value) ? value : value && typeof value === 'object' ? Object.values(value) : [];
                return options.filter(option => option && typeof option === 'object' && Number.isInteger(option.id) && option.id >= 0);
            },
            loadSubTypes() {
                if (this.disposed) return;
                const requestId = ++this.subTypeRequestId;
                const typeId = this.deviceTypeId;
                return axios
                    .get('api/v1/extended_settings/devices-types/' + this.deviceTypeId +'/sub-types')
                    .then((data) => {
                        if (this.disposed || requestId !== this.subTypeRequestId || typeId !== this.deviceTypeId) return;
                        this.deviceSubTypeList = this.normalizeSubTypes(data.data.rows);
                        this.isBusy = false;
                    })
                    .catch(() => undefined);
            },
            loadDeviceTypes() {
                if (this.disposed) return;
                const requestId = ++this.typeListRequestId;
                this.typeListLoading = true;
                this.typeListError = false;
                this.deviceTypeList = [];
                return axios.get('api/v1/devices/device-types')
                    .then(response => {
                        if (this.disposed || requestId !== this.typeListRequestId) return;
                        if (!Array.isArray(response.data.rows)) throw new Error('Invalid device type list');
                        this.deviceTypeList = response.data.rows;
                    })
                    .catch(() => { if (!this.disposed && requestId === this.typeListRequestId) this.typeListError = true; })
                    .finally(() => { if (!this.disposed && requestId === this.typeListRequestId) this.typeListLoading = false; });
            },
            initFutureAvailable() {
                let futureAvailable = {};

                if (localStorage.getItem('futureAvailable')) {
                    try {
                        futureAvailable = JSON.parse(localStorage.getItem('futureAvailable'));
                        if (!futureAvailable || typeof futureAvailable !== 'object' || Array.isArray(futureAvailable)) futureAvailable = {};
                    } catch(e) {
                        localStorage.removeItem('futureAvailable');
                    }
                }
                this.deviceInfoData.imei.changeAvailable = futureAvailable.changeImei === true;
                this.deviceInfoData.deviceType.changeAvailable = futureAvailable.changeDeviceType === true;
                this.deviceInfoData.deviceSubType.changeAvailable = futureAvailable.changeDeviceSubType === true;
            },
            onSubmit() {
                if (this.disposed || this.loading || this.loadError || this.savingAdditional || this.identitySaving) return;
                const deviceId = this.id;
                const requestId = ++this.saveRequestId;
                const submitted = JSON.parse(JSON.stringify({ ...this.additionalDataSource, ...this.deviceAdditionalInfo }));
                this.savingAdditional = true;
                this.showSuccessAlert = false;
                this.additionalSaveError = false;
                return axios
                    .post('api/v1/devices/' + deviceId +'/additional_data', submitted)
                    .then(() => {
                        this.$store.commit('clearDeviceList');
                        if (this.disposed || requestId !== this.saveRequestId) return;
                        this.additionalDataSource = submitted;
                        this.showSuccessAlert = true
                    })
                    .catch(() => {
                        if (!this.disposed && requestId === this.saveRequestId) this.additionalSaveError = true;
                    })
                    .finally(() => {
                        if (!this.disposed && requestId === this.saveRequestId) this.savingAdditional = false;
                    });
            },
            identityValue(field) {
                return this.deviceInfoData[field === 'deviceSubType' ? 'sub_type' : field].value;
            },
            identityChanged(field) {
                return this.identityValue(field) !== this.identityConfirmed[field];
            },
            onSaveImei() { return this.saveIdentity('imei', 'imei'); },
            onSaveDeviceType() { return this.saveIdentity('deviceType', 'device-type'); },
            onSaveDeviceSubType() { return this.saveIdentity('deviceSubType', 'sub-type'); },
            saveIdentity(field, endpoint) {
                if (this.disposed || this.loading || this.loadError || this.identitySaving || this.savingAdditional ||
                    !this.deviceInfoData[field].changeAvailable || !this.identityChanged(field)) return;
                if (field === 'deviceType' && (this.typeListLoading || this.typeListError)) return;
                const value = this.identityValue(field);
                const options = field === 'deviceType' ? this.deviceTypeList : this.deviceSubTypeList;
                const valid = field === 'imei' ? typeof value === 'string' && /^\d{15}$/.test(value)
                    : Number.isInteger(value) && value >= (field === 'deviceSubType' ? 0 : 1) && Array.isArray(options) && options.some(option => option.id === value);
                this.deviceInfoData[field].savedSuccess = false;
                this.identityErrors[field] = '';
                if (!valid) { this.identityErrors[field] = this.$t(field === 'imei' ? 'device_imei_invalid' : 'device_identity_invalid'); return; }
                const deviceId = this.id;
                const requestId = ++this.identityRequestId;
                const current = () => !this.disposed && requestId === this.identityRequestId;
                let confirmed = false;
                this.identitySaving = true;
                this.$emit('identity:pending');
                return axios.post('api/v1/devices/' + deviceId + '/' + endpoint, { [field]: value })
                    .then(response => {
                        if (response.data?.success !== true) throw new Error('Invalid identity response');
                        this.$store.commit('clearDeviceList');
                        if (!current()) return;
                        this.identityConfirmed[field] = value;
                        this.deviceInfoData[field].savedSuccess = true;
                        confirmed = true;
                    })
                    .catch(error => {
                        if (!current() || error.response?.status === 401) return;
                        const errors = error.response?.data?.errors;
                        const detail = error.response?.status === 400 && Array.isArray(errors)
                            ? errors.find(item => item?.field === field && typeof item.message === 'string') : null;
                        this.identityErrors[field] = detail?.message || this.$t(error.response?.status === 403 ? 'device_identity_forbidden' : 'device_identity_save_error');
                    })
                    .finally(() => {
                        if (!current()) return;
                        this.identitySaving = false;
                        if (confirmed) this.$emit('identity:changed');
                    });
            }

        },
        computed: {
            lang : {
                get() {
                    return this.$store.getters.getLang
                },
            }
        },
    }
</script>

<style scoped>

</style>
